import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    resend: 'Resend invitation',
    sending: 'Sending invitation...',
    sent: 'Invitation sent',
  },
  fr: {
    resend: 'Renvoyer une invitation',
    sending: 'Envoi de l’invitation en cours...',
    sent: 'Invitation envoyée',
  },
} as const);
